
































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator';
import { MediaObject } from '@/modules/media/types'
import FileSelector from '@/modules/media/components/FileSelector.vue'

@Component({
    components: {
        FileSelector,
    },
})
export default class FeaturedImage extends Vue {
    @Prop({type: MediaObject, default: () => new MediaObject() })
    public image: MediaObject

    public fileSelector = false

    public get hasImage (): boolean {
        return !!this.image.id
    }

    public resetImage () {
        this.$emit('change', new MediaObject())
    }

    public onImageSelect (image: MediaObject) {
        this.$emit('change', image)
        this.fileSelector = false
    }
}
